export default __webpack_public_path__ + "static/media/logo.4e3c756e.png";